<template>
  <div>
    <SidebarVue ref="sidebar" />
    <NavgatorDk
      ref="navgator"
      :barraTitulo="' Relatório Mensal - Desk'"
      :titulo="'relatório'"
    />

    <div class="card-container">
      <div class="card filter-container">
        <div class="row g-2 p-2">
          <div
            class="card-title gy-4 d-flex align-items-center justify-content-between"
          >
            <div class="d-flex align-items-center">
              <i class="bi bi-funnel fs-5 icon-text-form"></i>
              <span class="txt-title-form ms-2">Parâmetros do Relatório</span>
            </div>
            <!-- botão collapse em mobile -->
            <button
              class="btn btn-filtro d-inline-flex align-items-center"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#biFilters"
              aria-expanded="true"
              aria-controls="biFilters"
              style="max-width: 40px"
            >
              <i class="bi bi-chevron-down"></i>
            </button>
          </div>
        </div>

        <!-- Linha de Filtros -->
        <div class="row g-2 align-items-center">
          <!-- Seletor de Tipo de Relatório -->
          <div class="col-lg-2">
            <div class="form-floating txt-form-label">
              <select
                v-model="selectedRelatorio"
                @change="selecionarRelatorios()"
                class="form-select txt-form-input"
              >
                <option value="atendimentos">Fluxo de Lojas</option>
                <option value="venda_conversao">Conversão de Vendas</option>
                <option value="venda_perdida">Vendas Perdidas</option>
                <option value="venda_modelo">Vendas por Modelo</option>
              </select>
              <label><strong>Tipo de Relatório</strong></label>
            </div>
          </div>
          <div class="col-lg-2">
            <div
              class="form-floating txt-form-label"
              v-if="
                selectedRelatorio === 'venda_conversao' ||
                selectedRelatorio === 'venda_modelo'
              "
            >
              <select
                class="form-select txt-form-input"
                v-model="selectedTipoConversao"
              >
                <option
                  v-for="item in tipo_conversao"
                  :key="item.value"
                  :value="item.value"
                >
                  {{ item.nome }}
                </option>
              </select>
              <label><strong>Conversão por</strong></label>
            </div>
          </div>
          <div class="col-lg-2">
            <div
              class="form-floating txt-form-label"
              v-if="selectedRelatorio !== 'atendimentos'"
            >
              <select
                class="form-select txt-form-input"
                v-model="selectedTipoVeiculo"
              >
                <option
                  v-for="item in tipo_veiculo"
                  :key="item.value"
                  :value="item.value"
                >
                  {{ item.nome }}
                </option>
              </select>
              <label><strong>Veículo</strong></label>
            </div>
          </div>
          <!-- <div
              class="param-group"
              v-if="
                selectedRelatorio === 'venda_conversao' ||
                selectedRelatorio === 'venda_modelo'
              "
            >
              <label class="param-label">Conversão por</label>
              <div class="radio-group">
                <div
                  v-for="item in tipo_conversao"
                  :key="item.value"
                  class="radio-option"
                >
                  <input
                    type="radio"
                    :id="item.value"
                    :value="item.value"
                    v-model="selectedTipoConversao"
                    @click.stop
                    class="radio-input"
                  />
                  <label :for="item.value" class="radio-label">
                    <span class="radio-button"></span>
                    <span class="radio-text">{{ item.nome }}</span>
                  </label>
                </div>
              </div>
            </div> -->

          <!-- Seletor de Período -->
          <div class="col-lg-2">
            <div class="form-floating txt-form-label">
              <select
                v-model="selectedFilter"
                @change="filtarRelatorios()"
                class="form-select txt-form-input"
              >
                <option value="hoje">Hoje</option>
                <option value="ontem">Ontem</option>
                <option value="mes_atual">Mês Atual</option>
                <option value="mes_anterior">Mês Anterior</option>
                <option value="personalizado">Personalizado</option>
              </select>
              <label>Referência</label>
            </div>
          </div>

          <div class="col-lg-3">
            <div v-if="selectedFilter === 'personalizado'">
              <div class="form-floating txt-form-label input-group">
                <input
                  type="date"
                  v-model="startDate"
                  class="form-control txt-form-input"
                />
                <span class="input-group-text">até</span>
                <input
                  type="date"
                  v-model="endDate"
                  class="form-control txt-form-input"
                />
              </div>
            </div>
          </div>
          <div class="col-lg-1 d-flex justify-content-end">
            <div class="form-floating mt-1">
              <button
                class="btn round-btn"
                @click="
                  selectedRelatorio === 'venda_conversao'
                    ? relatorio_conversao_vendas()
                    : selectedRelatorio === 'venda_perdida'
                    ? relatorio_venda_perdida()
                    : selectedRelatorio === 'venda_modelo'
                    ? relatorio_venda_modelo()
                    : selectedRelatorio === 'atendimentos'
                    ? relatorio_atendimentos()
                    : null
                "
              >
                <i class="bi bi-search" title="Pesquisar"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="card filter-container">
        <div class="row g-2 p-2">
          <div
            class="card-title gy-4 d-flex align-items-center justify-content-between"
          >
            <div class="d-flex align-items-center">
              <i class="bi bi-shop fs-5 icon-text-form"></i>
              <span class="txt-title-form ms-2">Lojas</span>
            </div>
            <button
              class="btn btn-filtro d-inline-flex align-items-center"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#biFilters"
              aria-expanded="true"
              aria-controls="biFilters"
              style="max-width: 40px"
            >
              <i class="bi bi-chevron-down"></i>
            </button>
          </div>
          <div class="select-all mb-3">
            <div class="col-12 col-md-1 col-lg-1">
              <input
                class="btn-check"
                type="checkbox"
                id="checkboxTodos"
                v-model="marcarTodos"
                autocomplete="off"
              />
              <label class="btn btn-avaliacao" for="checkboxTodos"
                >Marcar Todos</label
              >
            </div>
            <div class="d-flex flex-wrap gap-2 align-items-center">
              <div
                v-for="item in lista_empresas"
                :key="'emp_' + item.id"
                class="filter-item-single-line"
              >
                <input
                  type="checkbox"
                  :id="'emp_' + item.id"
                  :value="item.id"
                  v-model="selectedEmpresas"
                  @click.stop
                  class="filter-checkbox"
                />
                <label :for="'emp_' + item.id" class="filter-label">
                  <span class="filter-icon"
                    ><i class="bi bi-building"></i
                  ></span>
                  <span class="filter-text">{{ item.nome }}</span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="filter-section">
        <div
          class="filter-header"
          data-bs-toggle="collapse"
          data-bs-target="#lojasCollapse"
          aria-expanded="true"
        >
          <i class="bi bi-shop-window icon-text-form"></i>
          <span class="txt-title-form">Lojas</span>
          <i class="bi bi-chevron-down collapse-icon icon-text-form"></i>
        </div>

        <div class="filter-content collapse show" id="lojasCollapse">
          <div class="select-all mb-3">
            <div class="form-check form-switch">
              <input
                class="form-check-input"
                type="checkbox"
                id="checkboxTodos"
                v-model="marcarTodos"
              />
              <label class="form-check-label" for="checkboxTodos"
                >Selecionar todas</label
              >
            </div>
          </div>

          <div class="d-flex flex-wrap gap-2 align-items-center">
            <div
              v-for="item in lista_empresas"
              :key="'emp_' + item.id"
              class="filter-item-single-line"
            >
              <input
                type="checkbox"
                :id="'emp_' + item.id"
                :value="item.id"
                v-model="selectedEmpresas"
                @click.stop
                class="filter-checkbox"
              />
              <label :for="'emp_' + item.id" class="filter-label">
                <span class="filter-icon"><i class="bi bi-building"></i></span>
                <span class="filter-text">{{ item.nome }}</span>
              </label>
            </div>
          </div>
        </div>
      </div> -->

        <!-- Filtro de Veículos - Versão Moderna -->
        <!-- <div class="filter-section" v-if="selectedRelatorio !== 'atendimentos'">
        <div
          class="filter-header"
          data-bs-toggle="collapse"
          data-bs-target="#veiculosCollapse"
          aria-expanded="true"
        >
          <i class="bi bi-car-front icon-text-form"></i>
          <span class="txt-title-form">Veículos</span>
          <i class="bi bi-chevron-down collapse-icon"></i>
        </div>

        <div class="filter-content collapse show" id="veiculosCollapse">
          <div class="box-conversao">
            <div class="form-check form-check-inline">
              <input
                class="form-check-input"
                type="checkbox"
                :id="'checkboxTodosVeiculos'"
                v-model="marcarTodosVeiculos"
              />
              <label class="form-check-label" :for="'checkboxTodosVeiculos'"
                >Ambos</label
              >
            </div>
            <div
              class="form-check form-check-inline"
              v-for="item in tipo_veiculo"
              :key="item.value"
            >
              <input
                class="form-check-input"
                type="checkbox"
                :id="item.value"
                :value="item.value"
                v-model="selectedTipoVeiculo"
              />
              <label class="form-check-label" :for="item.value">{{
                item.nome
              }}</label>
            </div>
          </div>
        </div>
      </div> -->
      </div>

      <!-- Cards de BI - Aparecem apenas para Conversão de Vendas e Vendas por Modelo -->
      <div
        class="row g-3 mb-4"
        v-if="
          selectedRelatorio === 'venda_conversao' ||
          selectedRelatorio === 'venda_modelo'
        "
      >
        <!-- Card 1: Visão Geral -->
        <div class="col-lg-3 col-md-6">
          <div class="bi-card">
            <div class="bi-card-header">
              <div
                class="bi-card-icon"
                :class="
                  selectedRelatorio === 'venda_conversao'
                    ? 'bg-primary'
                    : 'bg-success'
                "
              >
                <i class="bi bi-graph-up"></i>
              </div>
              <div class="bi-card-title">Visão Geral</div>
            </div>
            <div class="bi-card-body">
              <div
                class="bi-metric"
                v-if="selectedRelatorio === 'venda_conversao'"
              >
                <div class="metric-value">
                  {{ kpisConversao.totalAtendimentos || 0 }}
                </div>
                <div class="metric-label">Total de Atendimentos</div>
              </div>

              <div class="bi-metric" v-else>
                <div class="metric-value">{{ kpis.totalVendas || 0 }}</div>
                <div class="metric-label">Total de Vendas</div>
              </div>

              <div
                class="bi-metric"
                v-if="selectedRelatorio === 'venda_conversao'"
              >
                <div class="metric-value">
                  {{ kpisConversao.totalVendas || 0 }}
                </div>
                <div class="metric-label">Total de Vendas</div>
              </div>

              <div class="bi-metric" v-else>
                <div class="metric-value">{{ kpis.totalModelos || 0 }}</div>
                <div class="metric-label">Modelos Vendidos</div>
              </div>
            </div>
          </div>
        </div>

        <!-- Card 2: Performance -->
        <div class="col-lg-3 col-md-6">
          <div class="bi-card">
            <div class="bi-card-header">
              <div class="bi-card-icon bg-warning">
                <i class="bi bi-speedometer2"></i>
              </div>
              <div class="bi-card-title">Performance</div>
            </div>
            <div class="bi-card-body">
              <div class="bi-metric">
                <div class="metric-value">
                  {{ kpisConversao.conversaoGeral?.toFixed(1) || 0 }}%
                </div>
                <div class="metric-label">Taxa de Conversão Geral</div>
              </div>

              <div class="bi-metric">
                <div class="metric-value">
                  {{ kpisConversao.totalVendas || 0 }}
                </div>
                <div class="metric-label">Total de Vendas</div>
              </div>
            </div>
          </div>
        </div>

        <!-- Card 3: Novos vs Usados -->
        <div
          class="col-lg-3 col-md-6"
          v-if="selectedRelatorio === 'venda_conversao'"
        >
          <div class="bi-card">
            <div class="bi-card-header">
              <div class="bi-card-icon bg-info">
                <i class="bi bi-bar-chart-steps"></i>
              </div>
              <div class="bi-card-title">Novos vs Usados</div>
            </div>
            <div class="bi-card-body">
              <div class="bi-comparison">
                <div class="comparison-item">
                  <div class="comparison-label">Veículos Novos</div>
                  <div class="comparison-value">
                    {{ total_vendasNovos || 0 }}
                  </div>
                  <div class="comparison-percent">
                    {{ total_conversao_percNovos || "0%" }}
                  </div>
                </div>

                <div class="comparison-divider"></div>

                <div class="comparison-item">
                  <div class="comparison-label">Veículos Usados</div>
                  <div class="comparison-value">
                    {{ total_vendasUsados || 0 }}
                  </div>
                  <div class="comparison-percent">
                    {{ total_conversao_percUsados || "0%" }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Card 4: Top Conversão -->
        <div
          class="col-lg-3 col-md-6"
          v-if="selectedRelatorio === 'venda_conversao'"
        >
          <div class="bi-card">
            <div class="bi-card-header">
              <div class="bi-card-icon bg-danger">
                <i class="bi bi-trophy"></i>
              </div>
              <div class="bi-card-title">
                {{
                  selectedTipoConversao == 1
                    ? "Top Loja"
                    : selectedTipoConversao == 2
                    ? "Top Vendedor"
                    : "Top Modelo"
                }}
              </div>
            </div>

            <div class="bi-card-body">
              <div v-if="kpisConversao.topPerformance">
                <div class="performance-item">
                  <i class="bi bi-star-fill text-warning"></i>
                  <div class="performance-text">
                    {{ kpisConversao.topPerformance.descricao }}
                  </div>
                </div>

                <div class="performance-metric">
                  <div>
                    {{ kpisConversao.topPerformance.vendas }} vendas ({{
                      kpisConversao.totalVendas
                        ? (
                            (kpisConversao.topPerformance.vendas /
                              kpisConversao.totalVendas) *
                            100
                          ).toFixed(0)
                        : 0
                    }}%)
                  </div>

                  <div>
                    {{ kpisConversao.topPerformance.conversao.toFixed(1) }}%
                  </div>
                </div>
              </div>

              <div v-else class="text-muted text-center">Aguardando dados</div>
            </div>
          </div>
        </div>

        <!-- ===== VENDA MODELO ===== -->

        <!-- Top Modelos -->
        <div
          class="col-lg-3 col-md-6"
          v-if="selectedRelatorio === 'venda_modelo'"
        >
          <div class="bi-card">
            <div class="bi-card-header">
              <div class="bi-card-icon bg-danger">
                <i class="bi bi-trophy"></i>
              </div>
              <div class="bi-card-title">Top Modelos</div>
            </div>

            <div class="bi-card-body">
              <div class="bi-ranking">
                <div
                  v-for="(modelo, index) in kpis.top3 || []"
                  :key="index"
                  class="ranking-item"
                >
                  <div class="ranking-position">{{ index + 1 }}º</div>
                  <div class="ranking-name">{{ modelo.modelo }}</div>
                  <div class="ranking-value">
                    {{ modelo.vendas }} vendas ({{
                      modelo.participacao.toFixed(0)
                    }}%)
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Top Performance -->
        <div
          class="col-lg-3 col-md-6"
          v-if="selectedRelatorio === 'venda_modelo'"
        >
          <div class="bi-card">
            <div class="bi-card-header">
              <div class="bi-card-icon bg-success">
                <i class="bi bi-trophy"></i>
              </div>
              <div class="bi-card-title">
                {{ selectedTipoConversao == 1 ? "Top Loja" : "Top Vendedor" }}
              </div>
            </div>

            <div class="bi-card-body">
              <div v-if="kpis.topPerformance">
                <div class="performance-item">
                  <i class="bi bi-star-fill text-warning"></i>
                  <div class="performance-text">
                    {{ kpis.topPerformance.descricao }}
                  </div>
                </div>

                <div class="performance-metric">
                  <div>
                    {{ kpis.topPerformance.vendas }} vendas ({{
                      kpis.totalVendas
                        ? (
                            (kpis.topPerformance.vendas / kpis.totalVendas) *
                            100
                          ).toFixed(0)
                        : 0
                    }}%)
                  </div>
                </div>
              </div>

              <div v-else class="text-muted text-center">Aguardando dados</div>
            </div>
          </div>
        </div>
      </div>

      <div class="card card-tabela g-2 p-2">
        <div class="row g-2 p-2">
          <div class="card-title gy-4 linha">
            <i class="bi bi-graph-up-arrow icon-text-form"></i>
            <span class="txt-title-form">Relatório escolhido</span>
          </div>
          <div
            class="col-12 col-md-12 col-lg-12 d-flex justify-content-end gap-2"
          >
            <div class="form-floating">
              <button
                class="btn round-btn"
                v-if="selectedRelatorio === 'venda_conversao'"
                @click="exportToXLSX"
              >
                <i class="bi bi-filetype-xlsx"></i>
              </button>
              <button
                class="btn btn round-btn"
                v-if="selectedRelatorio === 'atendimentos'"
                @click="exportToXLSX_fluxo"
              >
                <i class="bi bi-filetype-xlsx"></i>
              </button>
              <button
                class="btn btn round-btn"
                v-if="selectedRelatorio === 'venda_perdida'"
                @click="exportToXLSX_perdida"
              >
                <i class="bi bi-filetype-xlsx"></i>
              </button>
              <button
                class="btn btn round-btn"
                v-if="selectedRelatorio === 'venda_modelo'"
                @click="exportToXLSX_modelo"
              >
                <i class="bi bi-filetype-xlsx"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="card-table-txt">
          <!--Conversão de Vendas-->

          <div v-if="selectedRelatorio === 'venda_conversao'">
            <!-- HEADER -->
            <div class="d-flex px-2 mb-2 fw-bold text-muted small">
              <div style="width: 260px"></div>

              <div class="flex-fill text-center">Novos</div>
              <div class="flex-fill text-center">Usados</div>
              <div class="flex-fill text-center">Total</div>
            </div>

            <!-- LINHAS -->
            <div
              v-for="item in conversao_vendas"
              :key="item.id"
              class="d-flex align-items-center mb-2 p-2 rounded"
              :style="{
                background:
                  item.Conversao >= 60
                    ? '#ecfdf5'
                    : item.Conversao >= 40
                    ? '#fffbeb'
                    : '#fef2f2'
              }"
            >
              <!-- EMPRESA (FIXA) -->
              <div
                class="d-flex align-items-center gap-2 fw-semibold"
                style="width: 260px"
              >
                <i class="bi bi-building"></i>
                <span class="truncate">{{ item.Descricao }}</span>
              </div>

              <!-- NOVOS -->
              <div class="flex-fill text-center">
                <div class="fw-bold fs-5">
                  {{ item.QuantidadeAtendimentosNovos }}
                </div>

                <div class="small text-muted">Atendimentos</div>

                <div class="small">{{ item.QuantidadeVendasNovos }} vendas</div>

                <div
                  class="small fw-semibold"
                  :class="
                    item.ConversaoNovos >= 50 ? 'text-success' : 'text-danger'
                  "
                >
                  {{ item.ConversaoNovos }}% conversão
                </div>

                <div
                  class="mx-auto mt-1"
                  style="width: 60%; height: 4px; background: #e5e7eb"
                >
                  <div
                    :style="{
                      width: item.ConversaoNovos + '%',
                      height: '100%',
                      background:
                        item.ConversaoNovos >= 50 ? '#16a34a' : '#dc2626'
                    }"
                  ></div>
                </div>
              </div>

              <!-- USADOS -->
              <div class="flex-fill text-center">
                <div class="fw-bold fs-5">
                  {{ item.QuantidadeAtendimentosUsados }}
                </div>

                <div class="small text-muted">Atendimentos</div>

                <div class="small">
                  {{ item.QuantidadeVendasUsados }} vendas
                </div>

                <div
                  class="small fw-semibold"
                  :class="
                    item.ConversaoUsados >= 50 ? 'text-success' : 'text-danger'
                  "
                >
                  {{ item.ConversaoUsados }}% conversão
                </div>

                <div
                  class="mx-auto mt-1"
                  style="width: 60%; height: 4px; background: #e5e7eb"
                >
                  <div
                    :style="{
                      width: item.ConversaoUsados + '%',
                      height: '100%',
                      background:
                        item.ConversaoUsados >= 50 ? '#16a34a' : '#dc2626'
                    }"
                  ></div>
                </div>
              </div>

              <!-- TOTAL -->
              <div class="flex-fill text-center">
                <div class="fw-bold fs-5">
                  {{ item.QuantidadeAtendimentos }}
                </div>

                <div class="small text-muted">Atendimentos</div>

                <div class="small">{{ item.QuantidadeVendas }} vendas</div>

                <div
                  class="small fw-semibold"
                  :class="item.Conversao >= 50 ? 'text-success' : 'text-danger'"
                >
                  {{ item.Conversao }}% conversão
                </div>

                <div
                  class="mx-auto mt-1"
                  style="width: 60%; height: 4px; background: #e5e7eb"
                >
                  <div
                    :style="{
                      width: item.Conversao + '%',
                      height: '100%',
                      background: item.Conversao >= 50 ? '#16a34a' : '#dc2626'
                    }"
                  ></div>
                </div>
              </div>
            </div>
          </div>

          <!--Venda Perdida-->

          <div class="table-responsive">
            <table
              id="VendaPerdida"
              class="table rf_texto mt-2"
              v-if="selectedRelatorio === 'venda_perdida'"
            >
              <thead>
                <tr>
                  <th scope="col" class="rf_header_table">Loja</th>
                  <th scope="col" class="rf_header_table">Atendente</th>
                  <th scope="col" class="rf_header_table">Gerente</th>
                  <th scope="col" class="rf_header_table">Data</th>
                  <th scope="col" class="rf_header_table">Hora</th>
                  <th scope="col" class="rf_header_table">Vendedor</th>
                  <th scope="col" class="rf_header_table">Cliente</th>
                  <th scope="col" class="rf_header_table">Telefone</th>
                  <th scope="col" class="rf_header_table">Telefone 2</th>
                  <th scope="col" class="rf_header_table">Motivo da Perda</th>
                  <th scope="col" class="rf_header_table">Veículo</th>
                  <th scope="col" class="rf_header_table">Categoria</th>
                  <th scope="col" class="rf_header_table">Valor</th>
                  <th scope="col" class="rf_header_table">Ações</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in filteredPerdidas" :key="item.id">
                  <td class="rf_header_table">
                    {{ item.empresa_proposta.nome ?? "-" }}
                  </td>
                  <td class="rf_header_table">
                    {{ item.usuarios.username ?? "-" }}
                  </td>
                  <td class="rf_header_table">
                    {{ item.gerente_alteracao.username ?? "-" }}
                  </td>
                  <td class="rf_header_table">
                    {{ this.formattedCreatedAt(item.updatedAt) ?? "-" }}
                  </td>
                  <td class="rf_header_table">
                    {{
                      this.formattedHoras(item.horario_inicio_atendimento) ??
                      "-"
                    }}
                  </td>
                  <td class="rf_header_table">
                    {{ item.proposta_vendedores.username ?? "-" }}
                  </td>
                  <td class="rf_header_table">
                    {{ item.clientes.nome ?? "-" }}
                  </td>
                  <td class="rf_header_table">
                    {{ this.formattedPhone(item.clientes.tel) ?? "-" }}
                  </td>
                  <td class="rf_header_table">
                    {{ this.formattedPhone(item.clientes.cel) ?? "-" }}
                  </td>
                  <td class="rf_header_table">
                    {{ item.motivo_venda_perdida ?? "-" }}
                  </td>
                  <td class="rf_header_table">
                    {{ item?.proposta_veiculo?.modelo_veiculo ?? "-" }}
                  </td>
                  <td class="rf_header_table">
                    {{ item?.proposta_veiculo?.categoria ?? "-" }}
                  </td>
                  <td class="rf_header_table">
                    {{ this.fmtBRL(item.val_sugerido_venda ?? "-") }}
                  </td>
                  <td class="rf_header_table">
                    <button
                      class="btn btn-sm btn-avaliacao"
                      @click="openModal(item)"
                    >
                      <i class="bi bi-eye"></i> Visualizar
                    </button>
                  </td>
                </tr>
                <tr v-if="filteredPerdidas.length === 0">
                  <td colspan="11" class="text-center py-4">
                    <i class="bi bi-inbox"></i> Nenhum registro encontrado
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!--Venda por Modelo-->
          <div class="table-responsive table-bi-container">
            <table
              class="table-bi"
              id="tabela_venda_modelo"
              v-if="selectedRelatorio === 'venda_modelo'"
            >
              <thead v-if="filtroSelecionadoLabel !== 'Loja'">
                <tr>
                  <th class="col-2">{{ filtroSelecionadoLabel }}</th>
                  <th class="col-3">Modelo</th>
                  <th class="col-1">Valor</th>
                  <th class="col-3">Cliente</th>
                  <th class="col-1">Telefone</th>
                  <th class="col-2">Loja</th>
                  <th></th>
                </tr>
              </thead>
              <thead v-if="filtroSelecionadoLabel !== 'Vendedor'">
                <tr>
                  <th class="col-5">{{ filtroSelecionadoLabel }}</th>
                  <th class="col-6">Modelo</th>
                  <th class="col-1">Vendas</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="item in vendas_modelo"
                  :key="item.id"
                  class="table-bi-row"
                >
                  <td>
                    <div class="cell-main">{{ item.Descricao }}</div>
                  </td>
                  <td class="rf_header_table"><div class="cell-main">{{ item.Modelo }}</div></td>
                  <td
                    v-if="filtroSelecionadoLabel !== 'Loja'"
                  >
                   <div class="cell-main"> {{ this.currency(item.Valor) }}</div>
                  </td>
                  <td
                    class="rf_header_table"
                    v-if="filtroSelecionadoLabel !== 'Loja'"
                  >
                    {{ item.Cliente }}
                  </td>
                  <td
                    class="rf_header_table"
                    v-if="filtroSelecionadoLabel !== 'Loja'"
                  >
                    {{ item.Telefone }}
                  </td>
                  <td
                    class="rf_header_table"
                    v-if="filtroSelecionadoLabel !== 'Loja'"
                  >
                    {{ item.Loja }}
                  </td>
                  <td
                    class="rf_header_table"
                    v-if="filtroSelecionadoLabel == 'Loja'"
                  >
                    {{ item.QuantidadeVendas }}
                  </td>
                  <th></th>
                </tr>
              </tbody>
              <thead>
                <tr>
                  <th scope="col" class="rf_header_table">Total</th>
                  <th scope="col" class="rf_header_table"></th>
                  <th scope="col" class="rf_header_table">
                    {{ this.total_vendas_modelo }}
                  </th>
                  <th scope="col" class="rf_header_table"></th>
                </tr>
              </thead>
            </table>
          </div>

          <div class="table-responsive table-bi-container">
            <table
              class="table-bi"
              id="tabela_atendientos"
              v-if="selectedRelatorio === 'atendimentos'"
              ref="contentToPrintFluxo"
            >
              <thead>
                <tr>
                  <th class="col-medium">Loja</th>
                  <th class="col-small">Atendimento</th>
                  <th class="col-date">Data</th>
                  <th class="col-medium">Atendente</th>
                  <th class="col-medium">Vendedor</th>
                  <th class="col-large">Cliente</th>
                  <th class="col-phone">Telefone</th>
                  <th class="col-small">Mídia</th>
                  <th class="col-small">Retorno</th>
                  <th class="col-small">
                    <div>Tipo</div>
                  </th>
                  <th class="col-medium">
                    <div>Gerente</div>
                  </th>
                  <th class="col-time">Tempo</th>
                  <th class="col-actions text-end">Ação</th>
                </tr>
              </thead>

              <tbody>
                <tr
                  v-for="item in atendimentos"
                  :key="item.id"
                  class="table-bi-row"
                >
                  <td>
                    <div class="cell-main truncate tooltip-wrapper">
                      {{ item.loja }}
                    </div>
                    <span class="tooltip-box">
                      {{ item.loja }}
                    </span>
                  </td>

                  <td>
                    <div class="cell-main">{{ item.atendimento }}</div>
                  </td>

                  <td>
                    <div class="cell-main">
                      {{ formattedCreatedAt(item.data) }}
                    </div>
                  </td>

                  <td>
                    <div class="cell-main">{{ item.atendente }}</div>
                  </td>

                  <td>
                    <div class="cell-main">{{ item.vendedor }}</div>
                  </td>

                  <td>
                    <div class="cell-main truncate tooltip-wrapper">
                      {{ item.cliente }}

                      <span class="tooltip-box">
                        {{ item.cliente }}
                      </span>
                    </div>
                    <div class="cell-sub">{{ item.email }}</div>
                  </td>

                  <td>
                    <div class="cell-main">{{ item.telefone }}</div>
                    <div class="cell-sub">{{ item.telefone2 }}</div>
                  </td>

                  <td>
                    <div class="cell-main">{{ item.midia }}</div>
                  </td>

                  <td>
                    <div class="cell-main">{{ item.retorno }}</div>
                  </td>

                  <td>
                    <div class="cell-main">{{ item.tipo_fechamento }}</div>
                  </td>

                  <td>
                    <div class="cell-main">{{ item?.gerente2 ?? "-" }}</div>
                  </td>

                  <td :class="getTempoClass(item.tempo_de_atendimento)">
                    <!-- MOSTRA DIA SÓ SE EXISTIR -->
                    <div
                      v-if="
                        separarDiaETempo(item.tempo_de_atendimento).dias > 0
                      "
                      class="cell-main"
                    >
                      {{ separarDiaETempo(item.tempo_de_atendimento).dias }} dia
                    </div>

                    <!-- TEMPO SEMPRE -->
                    <div class="cell-sub">
                      {{ separarDiaETempo(item.tempo_de_atendimento).tempo }} h
                    </div>
                  </td>

                  <td class="text-end">
                    <button
                      class="btn btn-sm btn-avaliacao"
                      @click="openModalFluxo(item)"
                    >
                      <i class="bi bi-eye"></i> Visualizar
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!--Modal detalhes venda perdida-->
    <div class="modal-overlay" v-if="showModalPerdidas" @click="closeModal">
      <div class="modal-container powerbi-modal" @click.stop>
        <!-- Header com gradiente e ícone -->
        <div class="powerbi-modal-header">
          <div class="d-flex align-items-center gap-2">
            <div class="powerbi-icon-wrapper">
              <i class="bi bi-x-octagon"></i>
            </div>
            <div>
              <h5 class="powerbi-modal-title">Venda Perdida - Detalhes</h5>
              <p class="powerbi-modal-subtitle">
                Informações completas da oportunidade perdida
              </p>
            </div>
          </div>
          <button type="button" class="powerbi-close-btn" @click="closeModal">
            <i class="bi bi-x-lg"></i>
          </button>
        </div>

        <div class="modal-body powerbi-modal-body" v-if="selectedItemPerdida">
          <!-- KPI Cards - Métricas principais -->
          <div class="powerbi-kpi-grid">
            <div class="powerbi-kpi-card">
              <div class="kpi-icon">
                <i class="bi bi-cash-stack"></i>
              </div>
              <div class="kpi-content">
                <div class="kpi-label">Valor</div>
                <div class="kpi-value">
                  {{ fmtBRL(selectedItemPerdida.val_sugerido_venda) ?? "-" }}
                </div>
              </div>
            </div>

            <div class="powerbi-kpi-card">
              <div class="kpi-icon">
                <i class="bi bi-hash"></i>
              </div>
              <div class="kpi-content">
                <div class="kpi-label">Atendimento Nº</div>
                <div class="kpi-value">
                  {{ selectedItemPerdida.id ?? "-" }}
                </div>
              </div>
            </div>

            <div class="powerbi-kpi-card">
              <div class="kpi-icon">
                <i class="bi bi-car-front"></i>
              </div>
              <div class="kpi-content">
                <div class="kpi-label">Veículo</div>
                <div class="kpi-value">
                  {{
                    selectedItemPerdida.proposta_veiculo?.modelo_veiculo ?? "-"
                  }}
                </div>
              </div>
            </div>

            <div class="powerbi-kpi-card">
              <div class="kpi-icon">
                <i class="bi bi-exclamation-triangle-fill"></i>
              </div>
              <div class="kpi-content">
                <div class="kpi-label">Tipo</div>
                <div class="kpi-value">
                  {{ selectedItemPerdida.proposta_veiculo?.categoria ?? "-" }}
                </div>
              </div>
            </div>
          </div>

          <!-- Seção Informações do Atendimento -->
          <div class="powerbi-section">
            <div class="powerbi-section-header">
              <i class="bi bi-person-badge"></i>
              <h6>Informações do Atendimento</h6>
              <div class="section-line"></div>
            </div>
            <div class="powerbi-info-grid">
              <div class="powerbi-info-item">
                <div class="info-label">
                  <i class="bi bi-building"></i> Loja
                </div>
                <div class="info-value">
                  {{ selectedItemPerdida.empresa_proposta?.nome ?? "-" }}
                </div>
              </div>
              <div class="powerbi-info-item">
                <div class="info-label">
                  <i class="bi bi-calendar3"></i> Data do Atendimento
                </div>
                <div class="info-value">
                  {{ formattedCreatedAt(selectedItemPerdida.updatedAt) ?? "-" }}
                </div>
              </div>
              <div class="powerbi-info-item">
                <div class="info-label">
                  <i class="bi bi-clock"></i> Horário
                </div>
                <div class="info-value">
                  {{
                    formattedHoras(
                      selectedItemPerdida.horario_inicio_atendimento
                    ) ?? "-"
                  }}
                </div>
              </div>
              <div class="powerbi-info-item">
                <div class="info-label">
                  <i class="bi bi-person-circle"></i> Cliente
                </div>
                <div class="info-value">
                  {{ selectedItemPerdida.clientes?.nome ?? "-" }}
                </div>
              </div>
              <div class="powerbi-info-item">
                <div class="info-label">
                  <i class="bi bi-telephone"></i> Telefone
                </div>
                <div class="info-value">
                  {{
                    this.formattedPhone(selectedItemPerdida.clientes?.tel) ??
                    "-"
                  }}
                </div>
              </div>
              <div class="powerbi-info-item">
                <div class="info-label">
                  <i class="bi bi-telephone-fill"></i> Telefone 2
                </div>
                <div class="info-value">
                  {{
                    this.formattedPhone(selectedItemPerdida.clientes?.cel) ||
                    "-"
                  }}
                </div>
              </div>
              <div class="powerbi-info-item">
                <div class="info-label">
                  <i class="bi bi-person"></i> Atendente
                </div>
                <div class="info-value">
                  {{ selectedItemPerdida.usuarios?.username ?? "-" }}
                </div>
              </div>
              <div class="powerbi-info-item">
                <div class="info-label">
                  <i class="bi bi-person-video3"></i> Vendedor
                </div>
                <div class="info-value">
                  {{ selectedItemPerdida.proposta_vendedores?.username ?? "-" }}
                </div>
              </div>
              <div class="powerbi-info-item">
                <div class="info-label">
                  <i class="bi bi-person-workspace"></i> Gerente
                </div>
                <div class="info-value">
                  {{ selectedItemPerdida.gerente_alteracao?.username ?? "-" }}
                </div>
              </div>
            </div>
          </div>

          <!-- Seção Informações do Veículo -->
          <div class="powerbi-section">
            <div class="powerbi-section-header">
              <i class="bi bi-car-front-fill"></i>
              <h6>Informações do Veículo</h6>
              <div class="section-line"></div>
            </div>

            <div class="powerbi-vehicle-highlight">
              <div class="vehicle-main-info">
                <div class="vehicle-icon">
                  <i class="bi bi-truck"></i>
                </div>
                <div class="vehicle-details">
                  <div class="vehicle-title">
                    {{ selectedItemPerdida.proposta_veiculo?.marca ?? "-" }}
                    {{
                      selectedItemPerdida.proposta_veiculo?.modelo_veiculo ??
                      "-"
                    }}
                  </div>
                  <div class="vehicle-subtitle">
                    {{ selectedItemPerdida.proposta_veiculo?.cor ?? "-" }}
                    |
                    {{
                      selectedItemPerdida.proposta_veiculo?.ano_modelo ?? "-"
                    }}
                  </div>
                </div>
              </div>
            </div>

            <div class="powerbi-info-grid">
              <div class="powerbi-info-item">
                <div class="info-label"><i class="bi bi-tag"></i> Modelo</div>
                <div class="info-value">
                  {{
                    selectedItemPerdida.proposta_veiculo?.modelo_veiculo ?? "-"
                  }}
                </div>
              </div>
              <div class="powerbi-info-item">
                <div class="info-label">
                  <i class="bi bi-grid-3x3-gap-fill"></i> Categoria
                </div>
                <div class="info-value">
                  {{ selectedItemPerdida.proposta_veiculo?.categoria ?? "-" }}
                </div>
              </div>
              <div class="powerbi-info-item">
                <div class="info-label">
                  <i class="bi bi-fuel-pump"></i> Combustível
                </div>
                <div class="info-value">
                  {{ selectedItemPerdida.proposta_veiculo?.combustivel ?? "-" }}
                </div>
              </div>
              <div class="powerbi-info-item">
                <div class="info-label">
                  <i class="bi bi-currency-dollar"></i> Valor Previsto
                </div>
                <div class="info-value">
                  {{
                    fmtBRL(
                      selectedItemPerdida.proposta_veiculo?.valor_veiculo
                    ) ?? "-"
                  }}
                </div>
              </div>
            </div>
          </div>

          <!-- Seção Motivo da Perda -->
          <div class="powerbi-section" v-if="selectedItemPerdida.motivo_perda">
            <div class="powerbi-section-header">
              <i class="bi bi-chat-square-quote"></i>
              <h6>Motivo da Perda</h6>
              <div class="section-line"></div>
            </div>
            <div class="powerbi-observations">
              <i class="bi bi-quote"></i>
              {{ selectedItemPerdida.motivo_perda }}
            </div>
          </div>
        </div>

        <div class="powerbi-modal-footer">
          <button
            type="button"
            class="powerbi-btn-secondary"
            @click="closeModal"
          >
            <i class="bi bi-x-circle"></i> Fechar
          </button>
        </div>
      </div>
    </div>

    <!--Modal detalhes fluxo de loja-->
    <div class="modal-overlay" v-if="showModalFluxo" @click="closeModal">
      <div class="modal-container powerbi-modal" @click.stop>
        <!-- Header com gradiente e ícone -->
        <div class="powerbi-modal-header">
          <div class="d-flex align-items-center gap-2">
            <div class="powerbi-icon-wrapper">
              <i class="bi bi-clipboard-data"></i>
            </div>
            <div>
              <h5 class="powerbi-modal-title">Detalhes do Atendimento</h5>
              <p class="powerbi-modal-subtitle">
                Informações completas do fluxo de atendimento
              </p>
            </div>
          </div>
          <button type="button" class="powerbi-close-btn" @click="closeModal">
            <i class="bi bi-x-lg"></i>
          </button>
        </div>

        <div class="modal-body powerbi-modal-body" v-if="selectedItemFluxo">
          <!-- KPI Cards - Métricas principais -->
          <div class="powerbi-kpi-grid">
            <div class="powerbi-kpi-card">
              <div class="kpi-icon">
                <i class="bi bi-hash"></i>
              </div>
              <div class="kpi-content">
                <div class="kpi-label">Atendimento Nº</div>
                <div class="kpi-value">
                  {{ selectedItemFluxo.atendimento ?? "-" }}
                </div>
              </div>
            </div>

            <div class="powerbi-kpi-card">
              <div class="kpi-icon">
                <i class="bi bi-building"></i>
              </div>
              <div class="kpi-content">
                <div class="kpi-label">Loja</div>
                <div class="kpi-value">
                  {{ selectedItemFluxo.loja ?? "-" }}
                </div>
              </div>
            </div>

            <div class="powerbi-kpi-card">
              <div class="kpi-icon">
                <i class="bi bi-person-circle"></i>
              </div>
              <div class="kpi-content">
                <div class="kpi-label">Cliente</div>
                <div class="kpi-value">
                  {{ selectedItemFluxo.cliente ?? "-" }}
                </div>
              </div>
            </div>

            <div class="powerbi-kpi-card">
              <div class="kpi-icon">
                <i class="bi bi-clock-history"></i>
              </div>
              <div class="kpi-content">
                <div class="kpi-label">Tempo Atendimento</div>
                <div class="kpi-value">
                  {{ selectedItemFluxo.tempo_de_atendimento ?? "-" }}
                </div>
              </div>
            </div>
          </div>

          <!-- Seção Informações do Atendimento -->
          <div class="powerbi-section">
            <div class="powerbi-section-header">
              <i class="bi bi-person-badge"></i>
              <h6>Informações do Atendimento</h6>
              <div class="section-line"></div>
            </div>
            <div class="powerbi-info-grid">
              <div class="powerbi-info-item">
                <div class="info-label">
                  <i class="bi bi-calendar3"></i> Data
                </div>
                <div class="info-value">
                  {{ formattedCreatedAt(selectedItemFluxo.data) ?? "-" }}
                </div>
              </div>
              <div class="powerbi-info-item">
                <div class="info-label">
                  <i class="bi bi-person"></i> Atendente
                </div>
                <div class="info-value">
                  {{ selectedItemFluxo.atendente ?? "-" }}
                </div>
              </div>
              <div class="powerbi-info-item">
                <div class="info-label">
                  <i class="bi bi-person-video3"></i> Vendedor
                </div>
                <div class="info-value">
                  {{ selectedItemFluxo.vendedor ?? "-" }}
                </div>
              </div>
              <div class="powerbi-info-item">
                <div class="info-label">
                  <i class="bi bi-person-workspace"></i> Gerente Fechamento
                </div>
                <div class="info-value">
                  {{ selectedItemFluxo?.gerente2 ?? "-" }}
                </div>
              </div>
              <div class="powerbi-info-item">
                <div class="info-label">
                  <i class="bi bi-envelope"></i> Email
                </div>
                <div class="info-value">
                  {{ selectedItemFluxo.email ?? "-" }}
                </div>
              </div>
              <div class="powerbi-info-item">
                <div class="info-label">
                  <i class="bi bi-telephone"></i> Telefone
                </div>
                <div class="info-value">
                  {{ formattedPhone(selectedItemFluxo.telefone) ?? "-" }}
                </div>
              </div>
              <div class="powerbi-info-item">
                <div class="info-label">
                  <i class="bi bi-telephone-fill"></i> Telefone 2
                </div>
                <div class="info-value">
                  {{ formattedPhone(selectedItemFluxo.telefone2) ?? "-" }}
                </div>
              </div>
              <div class="powerbi-info-item">
                <div class="info-label">
                  <i class="bi bi-broadcast"></i> Mídia
                </div>
                <div class="info-value">
                  {{ selectedItemFluxo.midia ?? "-" }}
                </div>
              </div>
              <div class="powerbi-info-item">
                <div class="info-label">
                  <i class="bi bi-arrow-repeat"></i> Retorno
                </div>
                <div class="info-value">
                  {{ selectedItemFluxo.retorno ?? "-" }}
                </div>
              </div>
              <div class="powerbi-info-item">
                <div class="info-label">
                  <i class="bi bi-check2-circle"></i> Tipo Fechamento
                </div>
                <div class="info-value">
                  {{ selectedItemFluxo.tipo_fechamento ?? "-" }}
                </div>
              </div>
              <div class="powerbi-info-item">
                <div class="info-label">
                  <i class="bi bi-door-open"></i> Primeiro Acesso
                </div>
                <div class="info-value">
                  {{ selectedItemFluxo?.gerente ?? "-" }}
                </div>
              </div>
              <div class="powerbi-info-item">
                <div class="info-label">
                  <i class="bi bi-menu-button-wide"></i> Menus
                </div>
                <div class="info-value">
                  {{ selectedItemFluxo.menu ?? "-" }}
                </div>
              </div>
            </div>
          </div>

          <!-- Seção Observações -->
          <div class="powerbi-section" v-if="selectedItemFluxo.observacao">
            <div class="powerbi-section-header">
              <i class="bi bi-chat-text"></i>
              <h6>Observações</h6>
              <div class="section-line"></div>
            </div>
            <div class="powerbi-observations">
              <i class="bi bi-quote"></i>
              {{ selectedItemFluxo.observacao }}
            </div>
          </div>
        </div>

        <div class="powerbi-modal-footer">
          <button
            type="button"
            class="powerbi-btn-secondary"
            @click="closeModal"
          >
            <i class="bi bi-x-circle"></i> Fechar
          </button>
        </div>
      </div>
    </div>

    <RodapeVue />
  </div>
</template>
<script>
import SidebarVue from "../../components/menu/Sidebar.vue";
import axios from "axios";
import TokenService from "../../services/token.service";
import jwt_decode from "jwt-decode";
import XLSX from "xlsx/dist/xlsx.full.min";
import RodapeVue from "../../components/menu/Rodape.vue";
import NavgatorDk from "../../components/menu/NavgatorDk.vue";

export default {
  components: {
    SidebarVue,
    NavgatorDk,
    RodapeVue
  },
  data() {
    return {
      lucro_operacional: "",
      lucro_gerencial: "",
      lucro_financiamento: "",
      lucro_final: "",

      total_passagem_zero: "",
      total_passagem_zero_retorno: "",
      total_passagem_zero_novas: "",
      total_em_atendimento_zero: "",
      total_em_atendimento_zero_porcentagem: "",
      total_vendas_perdidas_zero: "",
      total_vendas_perdidas_zero_porcentagem: "",
      total_vendas_finalizadas_zero: "",
      total_vendas_finalizadas_zero_porcentagem: "",
      total_vendas_finalizadas_zero_novos: "",
      total_vendas_finalizadas_zero_novos_porcentagem: "",
      total_vendas_finalizadas_zero_retorno: "",
      total_vendas_finalizadas_zero_retorno_porcentagem: "",

      total_conversao_perc: "",
      total_conversao_percUsados: "",

      total_passagem_usado: "",
      total_passagem_usado_retorno: "",
      total_passagem_usado_novas: "",
      total_em_atendimento_usados: "",
      total_em_atendimento_usados_porcentagem: "",
      total_vendas_perdidas_usados: "",
      total_vendas_perdidas_usados_porcentagem: "",
      total_vendas_finalizadas_usado: "",
      total_vendas_finalizadas_usado_porcentagem: "",
      total_vendas_finalizadas_usado_novos: "",
      total_vendas_finalizadas_usado_novos_porcentagem: "",
      total_vendas_finalizadas_usado_retorno: "",
      total_vendas_finalizadas_usado_retorno_porcentagem: "",
      conversao_vendas: [],
      total_atendimentos: "",
      total_vendas: "",
      selectedFilter: "hoje",
      startDate: "",
      endDate: "",

      //Dados do Login
      user_id: "",
      company_id: "",
      lista_empresas: [],
      selectedEmpresas: [],
      selectedEmpresasFiltradas: [],
      selectedEmpresasFiltradasIds: [],
      selectedTipoConversaoIds: [],

      marcarTodos: true,
      marcarTodosVeiculos: true,
      tipo_veiculo: [],
      tipo_conversao: [],
      selectedTipoConversao: 1,
      selectedTipoVeiculo: 2,
      selectedTipoVeiculoIds: [],
      atendimentos: [],
      marcarNovo: false,
      marcarUsado: false,
      referencia: "",
      filtroSelecionadoLabel: "Loja",
      selectedRelatorio: "venda_conversao",
      tipo_relatorio: "venda_conversao",
      vendas_perdidas: [],
      vendas_modelo: [],
      total_vendas_modelo: "",
      total_convesao_perc: 0.0,
      searchTerm: "",
      showModalPerdidas: false,
      selectedItemPerdida: null,
      selectedItemFluxo: null,
      showModalFluxo: false,
      kpis: {},
      kpisConversao: {}
    };
  },
  computed: {
    filteredPerdidas() {
      if (!this.searchTerm) {
        return this.vendas_perdidas;
      }

      const searchLower = this.searchTerm.toLowerCase();

      return this.vendas_perdidas.filter((item) => {
        const searchableFields = {
          loja: item.empresa_proposta?.nome || "",
          atendente: item.usuarios?.username || "",
          gerente: item.gerente_alteracao?.username || "",
          vendedor: item.proposta_vendedores?.username || "",
          cliente: item.clientes?.nome || "",
          telefone: item.clientes?.tel || "",
          telefone2: item.clientes?.cel || "",
          data: item.updatedAt || "",
          inicio_atendimento: item.horario_inicio_atendimento || "",
          motivo_perda: item.motivo_venda_perdida || "",
          veiculo: item.proposta_veiculo?.modelo_veiculo || "",
          valor: item.val_sugerido_venda || "",
          tipo_veiculo: item.proposta_veiculo?.categoria || ""
        };

        // Verificar se algum campo contém o termo de busca
        return Object.values(searchableFields).some((value) =>
          String(value).toLowerCase().includes(searchLower)
        );
      });
    },

    melhorPerformance() {
      if (!this.conversao_vendas || this.conversao_vendas.length === 0)
        return null;

      const calcularScore = (item) => {
        const atendimentos = item.QuantidadeAtendimentos || 0;
        const vendas = item.QuantidadeVendas || 0;
        const conversao = atendimentos > 0 ? vendas / atendimentos : 0;
        const confianca = Math.min(atendimentos / 20, 1);
        const bonusVolume = Math.min(vendas / 10, 1);
        return conversao * confianca * 0.7 + bonusVolume * 0.3;
      };

      const melhor = this.conversao_vendas.reduce((melhor, atual) => {
        const scoreAtual = calcularScore(atual);
        const scoreMelhor = calcularScore(melhor);
        return scoreAtual > scoreMelhor ? atual : melhor;
      }, this.conversao_vendas[0]);
      console.log("Dados de conversão", melhor);
      return {
        descricao: melhor.Descricao || "Não especificado",
        atendimentos: melhor.QuantidadeAtendimentos || 0,
        vendas: melhor.QuantidadeVendas || 0,
        conversao:
          ((melhor.QuantidadeVendas || 0) /
            (melhor.QuantidadeAtendimentos || 1)) *
          100,
        score: calcularScore(melhor),
        dadosCompletos: melhor
      };
    },
    topPerformanceModelo() {
      console.log("DEBUG vendas_modelo:", this.vendas_modelo);

      if (!this.vendas_modelo || this.vendas_modelo.length === 0) return null;

      const melhor = this.vendas_modelo.reduce((melhor, atual) => {
        return (atual.QuantidadeVendas || 0) > (melhor.QuantidadeVendas || 0)
          ? atual
          : melhor;
      }, this.vendas_modelo[0]);

      console.log("TOP ENCONTRADO:", melhor);

      return {
        descricao: melhor.Descricao || "Não especificado",
        modelo: melhor.Modelo || "-",
        vendas: melhor.QuantidadeVendas || 0,
        valor: melhor.Valor || 0
      };
    }
  },
  mounted() {
    this.getToken();
    this.getEmpresas();
  },
  watch: {
    selectedEmpresas(newVal) {
      console.log("Empresas selecionadas:", newVal, typeof newVal[0]);
    },

    marcarTodos(newVal) {
      if (newVal) {
        this.selectedEmpresas = this.lista_empresas.map((item) => item.id);
      } else {
        this.selectedEmpresas = [];
      }
    },

    marcarTodosVeiculos(newVal) {
      if (newVal) {
        this.selectedTipoVeiculo = this.tipo_veiculo.map((item) => item.value);
      } else {
        this.selectedTipoVeiculo = [];
      }
    },
    selectedTipoVeiculo(newVal) {
      // if (newVal == 1) {
      //  this.selectedTipoVeiculo = 1
      // } else if (newVal == 2) {
      //   this.selectedTipoVeiculo = 2
      // } else if (newVal == 3) {
      //   this.selectedTipoVeiculo = 3
      // }
      console.log("Tipo Veiculo:", newVal, typeof newVal);
    },
    selectedTipoConversao(newVal) {
      if (newVal == 1) {
        this.filtroSelecionadoLabel = "Loja";
      } else if (newVal == 2) {
        this.filtroSelecionadoLabel = "Vendedor";
      } else if (newVal == 3) {
        this.filtroSelecionadoLabel = "Veículo";
      }
      console.log("Tipo conversão selecionado:", newVal, typeof newVal);
    },
    lista_empresas: {
      handler() {
        this.selectedTipoVeiculo = 2;
        //this.handleVeiculoChange();
      },
      immediate: true
    }
  },
  created() {
    this.tipo_veiculo = [
      { nome: "Ambos", value: 2 },
      { nome: "Novos", value: 3 },
      { nome: "Usados", value: 1 }
    ];
    this.tipo_conversao = [
      { nome: "Loja", value: 1 },
      { nome: "Vendedor", value: 2 },
      { nome: "Veículo", value: 3 }
    ];
  },
  methods: {
    // handleVeiculoChange() {
    //   if (this.selectedTipoVeiculo == 2) {
    //     this.selectedTipoVeiculoIds = [0, 1];
    //   } else {
    //     this.selectedTipoVeiculoIds = [this.selectedTipoVeiculo];
    //   }

    //   console.log("ENVIANDO:", this.selectedTipoVeiculoIds);
    // },
    calcularMediaVendasPorModelo() {
      if (!this.vendas_modelo || this.vendas_modelo.length === 0) return "0";
      const total = this.vendas_modelo.reduce(
        (sum, item) => sum + (item.QuantidadeVendas || 0),
        0
      );
      const media = total / this.vendas_modelo.length;
      return media.toFixed(1);
    },

    calcularValorTotalVendasModelo() {
      if (!this.vendas_modelo || this.vendas_modelo.length === 0) return "R$ 0";
      const total = this.vendas_modelo.reduce(
        (sum, item) => sum + (item.Valor || 0),
        0
      );
      return this.currency(total);
    },

    getTopModelos(limit) {
      if (!this.vendas_modelo || this.vendas_modelo.length === 0) return [];
      return [...this.vendas_modelo]
        .sort((a, b) => (b.QuantidadeVendas || 0) - (a.QuantidadeVendas || 0))
        .slice(0, limit);
    },

    openModal(item) {
      // Desembrulha o proxy e clona para um objeto simples
      this.selectedItemPerdida = item;
      this.showModalPerdidas = true;
      console.log("Dados do item", item);
    },

    closeModal() {
      this.showModalPerdidas = false;
      this.selectedItemPerdida = null;
      this.selectedItemFluxo = null;
      this.showModalFluxo = false;
    },
    openModalFluxo(item) {
      this.selectedItemFluxo = item;
      this.showModalFluxo = true;
      console.log("Dados do atendimento", this.selectedItemFluxo);
    },
    exportToXLSX() {
      const table = document.getElementById("tabela_conversao");
      const rows = table.querySelectorAll("tr");
      const data = [];

      rows.forEach((row) => {
        const rowData = [];
        const cells = row.querySelectorAll("td, th");
        cells.forEach((cell) => {
          rowData.push(cell.innerText);
        });
        data.push(rowData);
      });

      const ws = XLSX.utils.aoa_to_sheet(data);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Dados");
      XLSX.writeFile(wb, "conversao_vendas.xlsx");
    },

    exportToXLSX_fluxo() {
      const table = document.getElementById("tabela_atendientos");
      const rows = table.querySelectorAll("tr");
      const data = [];

      rows.forEach((row) => {
        const rowData = [];
        const cells = row.querySelectorAll("td, th");
        cells.forEach((cell) => {
          rowData.push(cell.innerText);
        });
        data.push(rowData);
      });

      const ws = XLSX.utils.aoa_to_sheet(data);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Dados");
      XLSX.writeFile(wb, "fluxo_lojas.xlsx");
    },

    exportToXLSX_perdida() {
      const table = document.getElementById("VendaPerdida");
      const rows = table.querySelectorAll("tr");
      const data = [];

      rows.forEach((row) => {
        const rowData = [];
        const cells = row.querySelectorAll("td, th");
        cells.forEach((cell) => {
          rowData.push(cell.innerText);
        });
        data.push(rowData);
      });

      const ws = XLSX.utils.aoa_to_sheet(data);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Dados");
      XLSX.writeFile(wb, "venda_perdida.xlsx");
    },

    exportToXLSX_modelo() {
      const table = document.getElementById("tabela_venda_modelo");
      const rows = table.querySelectorAll("tr");
      const data = [];

      rows.forEach((row) => {
        const rowData = [];
        const cells = row.querySelectorAll("td, th");
        cells.forEach((cell) => {
          rowData.push(cell.innerText);
        });
        data.push(rowData);
      });

      const ws = XLSX.utils.aoa_to_sheet(data);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Dados");
      XLSX.writeFile(wb, "venda_modelo.xlsx");
    },

    formattedCreatedAt(item) {
      const date = new Date(item);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    },
    formattedPhone(phone) {
      const phoneStr = String(phone);
      const ddd = phoneStr.slice(0, 2);

      if (phoneStr.length === 11) {
        return `(${ddd}) ${phoneStr.slice(2, 7)}-${phoneStr.slice(7, 11)}`;
      } else if (phoneStr.length === 10) {
        return `(${ddd}) ${phoneStr.slice(2, 6)}-${phoneStr.slice(6, 10)}`;
      }

      return phoneStr;
    },
    formattedHoras(item) {
      const date = new Date(item);
      // Adicione 3 horas ao objeto Date
      date.setHours(date.getHours() + 3);

      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");
      return `${hours}:${minutes}:${seconds}`;
    },

    formatTime(date) {
      if (!date) return "";

      const d = new Date(date);

      return d.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit"
      });
    },
    formatDate(date) {
      if (!date) return "";

      const d = new Date(date);

      return d.toLocaleDateString("pt-BR");
    },
    separarDiaETempo(valor) {
      if (!valor) return { dias: 0, tempo: "00:00:00" };

      const match = valor.match(/(\d+)D\s+(\d{2}:\d{2}:\d{2})/);

      if (!match) return { dias: 0, tempo: valor };

      return {
        dias: parseInt(match[1], 10),
        tempo: match[2]
      };
    },

    getTempoClass(valor) {
      if (!valor) return "tempo-default";

      const match = valor.match(/(\d+)D\s+(\d+):(\d+):(\d+)/);

      if (!match) return "tempo-default";

      const dias = parseInt(match[1], 10);
      const horas = parseInt(match[2], 10);
      const minutos = parseInt(match[3], 10);

      // 🔥 regra
      if (dias > 0) return "tempo-critico";

      const totalMin = horas * 60 + minutos;

      if (totalMin <= 30) return "tempo-rapido";
      if (totalMin <= 120) return "tempo-medio";

      return "tempo-lento";
    },

    getToken() {
      const accessToken = TokenService.getLocalAccessToken();

      // Obter o token de atualização (refresh token)
      TokenService.getLocalRefreshToken();

      // Obter o usuário completo (incluindo os tokens) se necessário
      TokenService.getUser();

      const decodedToken = jwt_decode(accessToken);
      console.log(decodedToken);
      this.company_id = decodedToken.company;
      this.user_id = decodedToken.id;
    },
    getRequestParams(
      EmpresasSelecionadas,
      page,
      pageSize,
      empresa_id,
      usuario_id,
      data_ini,
      data_fim,
      tipo_veiculo,
      tipo_conversao,
      referencia
    ) {
      let params = {};
      if (EmpresasSelecionadas) {
        params["ids"] = EmpresasSelecionadas;
      }
      if (page) {
        params["page"] = page - 1;
      }
      if (pageSize) {
        params["size"] = pageSize;
      }
      if (empresa_id) {
        params["empresa_id"] = empresa_id;
      }
      if (usuario_id) {
        params["usuario_id"] = usuario_id;
      }
      if (data_ini) {
        params["data_ini"] = data_ini;
      }
      if (data_fim) {
        params["data_fim"] = data_fim;
      }
      if (tipo_veiculo) {
        params["tipo_veiculo"] = tipo_veiculo;
      }
      if (tipo_conversao) {
        params["tipo_conversao"] = tipo_conversao;
      }
      if (referencia) {
        params["referencia"] = referencia;
      }

      return params;
    },
    selecionarRelatorios() {
      if (this.selectedRelatorio === "venda_conversao") {
        this.tipo_conversao = [
          { nome: "Loja", value: 1 },
          { nome: "Vendedor", value: 2 },
          { nome: "Veículo", value: 3 }
        ];
      } else if (this.selectedRelatorio === "venda_modelo") {
        this.tipo_conversao = [
          { nome: "Loja", value: 1 },
          { nome: "Vendedor", value: 2 }
        ];
      } else if (this.selectedRelatorio === "atendimentos") {
        this.tipo_conversao = [
          { nome: "Loja", value: 1 },
          { nome: "Vendedor", value: 2 }
        ];
      }

      // 🔥 CORREÇÃO AQUI
      const valoresValidos = this.tipo_conversao.map((i) => i.value);

      if (!valoresValidos.includes(this.selectedTipoConversao)) {
        this.selectedTipoConversao = valoresValidos[0];
      }
    },
    filtarRelatorios() {
      if (this.selectedFilter === "hoje") {
        this.referencia = this.selectedFilter;
      } else if (this.selectedFilter === "ontem") {
        this.referencia = this.selectedFilter;
      } else if (this.selectedFilter === "mes_atual") {
        this.referencia = this.selectedFilter;
      } else if (this.selectedFilter === "mes_anterior") {
        this.referencia = this.selectedFilter;
      }
    },

    async relatorio_conversao_vendas() {
      console.log("Conversão de Vendas");
      const params = this.getRequestParams(
        this.selectedEmpresas,
        this.page,
        this.pageSize,
        this.company_id,
        this.user_id,
        this.startDate,
        this.endDate,
        this.selectedTipoVeiculo,
        this.selectedTipoConversao,
        this.selectedFilter
      );
      try {
        var conversaoNovos;
        var conversaoUsados;
        const response = await axios.get(
          `${process.env.VUE_APP_API_URL}relatorio_conversao_vendas`,
          {
            params
          }
        );
        console.log("Relatorio Desk", response.data.result);
        const qtd = response.data.result.length;
        this.conversao_vendas = [];
        this.kpisConversao = response.data.kpis || {};
        for (let i = 0; i < qtd; i++) {
          var totalVendasNovos = response.data.result[i].QuantidadeVendasNovos;
          var totalVendasUsados =
            response.data.result[i].QuantidadeVendasUsados;
          var totalAtendimentoNovos =
            response.data.result[i].QuantidadeAtendimentosNovos;
          var totalAtendimentosUsados =
            response.data.result[i].QuantidadeAtendimentosUsados;

          conversaoUsados = parseFloat(
            (totalVendasUsados / totalAtendimentosUsados) * 100
          ).toFixed(2);

          if (totalAtendimentoNovos != 0) {
            conversaoNovos = parseFloat(
              (totalVendasNovos / totalAtendimentoNovos) * 100
            ).toFixed(2);
          } else {
            conversaoNovos = 0;
          }

          if (totalAtendimentosUsados != 0) {
            conversaoUsados = parseFloat(
              (totalVendasUsados / totalAtendimentosUsados) * 100
            ).toFixed(2);
          } else {
            conversaoUsados = 0;
          }

          const arr = {
            Descricao: response.data.result[i].Descricao,
            Conversao: parseFloat(
              response.data.result[i].Conversao * 100
            ).toFixed(2),
            ConversaoNovos: conversaoNovos,
            ConversaoUsados: conversaoUsados,
            QuantidadeAtendimentos:
              response.data.result[i].QuantidadeAtendimentos,
            QuantidadeAtendimentosNovos:
              response.data.result[i].QuantidadeAtendimentosNovos,
            QuantidadeAtendimentosUsados:
              response.data.result[i].QuantidadeAtendimentosUsados,
            QuantidadeVendas: response.data.result[i].QuantidadeVendas,
            QuantidadeVendasNovos:
              response.data.result[i].QuantidadeVendasNovos,
            QuantidadeVendasUsados:
              response.data.result[i].QuantidadeVendasUsados
          };

          this.conversao_vendas.push(arr); // Adiciona o novo objeto ao array
        }

        this.total_atendimentos = response.data.total[0]["TotalAtendimentos"];
        this.total_vendas = response.data.total[0]["TotalVendas"];

        this.total_atendimentosNovos =
          response.data.total[0]["TotalAtendimentosNovos"];
        this.total_vendasNovos = response.data.total[0]["TotalVendasNovos"];

        this.total_atendimentosUsados =
          response.data.total[0]["TotalAtendimentosUsados"];
        this.total_vendasUsados = response.data.total[0]["TotalVendasUsados"];

        if (this.total_atendimentos !== 0) {
          this.total_conversao_perc = parseFloat(
            (this.total_vendas / this.total_atendimentos) * 100
          ).toFixed(2);
        } else {
          // Defina um valor padrão ou trate de outra forma, dependendo dos requisitos.
          this.total_conversao_perc = 0.0; // Por exemplo, definindo como 0 quando não há atendimentos.
        }

        if (this.total_atendimentosNovos !== 0) {
          this.total_conversao_percNovos = parseFloat(
            (this.total_vendasNovos / this.total_atendimentosNovos) * 100
          ).toFixed(2);
        } else {
          // Defina um valor padrão ou trate de outra forma, dependendo dos requisitos.
          this.total_conversao_percNovos = 0.0; // Por exemplo, definindo como 0 quando não há atendimentos novos.
        }

        if (this.total_atendimentosUsados !== 0) {
          this.total_conversao_percUsados = parseFloat(
            (this.total_vendasUsados / this.total_atendimentosUsados) * 100
          ).toFixed(2);
        } else {
          // Defina um valor padrão ou trate de outra forma, dependendo dos requisitos.
          this.total_conversao_percUsados = 0.0; // Por exemplo, definindo como 0 quando não há atendimentos usados.
        }
      } catch (error) {
        console.log(error);
        this.abrir_modal = true;
        this.msg = error;
        setTimeout(() => (this.abrir_modal = false), 4000);
      }
    },
    async relatorio_venda_perdida() {
      console.log("chamar relatório de venda perdida");

      // Limpa o array antes de adicionar novos elementos

      const params = this.getRequestParams(
        this.selectedEmpresas,
        this.page,
        this.pageSize,
        this.company_id,
        this.user_id,
        this.startDate,
        this.endDate,
        this.selectedTipoVeiculo,
        this.selectedTipoConversao,
        this.selectedFilter
      );
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API_URL}relatorio_vendas_perdida`,
          { params }
        );
        console.log("Relatório vendas perdidas", response.data.rows);
        this.vendas_perdidas = response.data.rows;

        // const qtd = response.data.count;
        // const { rows } = response.data;
        // console.log("Dados do relatórios de vendas perdidas");
        // console.log(rows);
        // for (let i = 0; i < qtd; i++) {
        //   const modelo_veiculo = rows[i].proposta_veiculo?.modelo_veiculo || ""; // Verifica se é null
        //   const categoria = rows[i].proposta_veiculo?.categoria || "";
        //   const valor_veiculo = rows[i].proposta_veiculo?.valor_veiculo || 0.0;
        //   const arr = {
        //     loja: rows[i].empresa_proposta.nome,
        //     atendente: rows[i].usuarios.username,
        //     gerente: rows[i].gerente_alteracao.username,
        //     vendedor: rows[i].proposta_vendedores.username,
        //     cliente: rows[i].clientes.nome,
        //     telefone: rows[i].clientes.tel,
        //     telefone2: rows[i].clientes.cel,
        //     data: rows[i].createdAt,
        //     inicio_atendimento: rows[i].horario_inicio_atendimento,
        //     motivo_perda: rows[i].motivo_venda_perdida,
        //     veiculo: modelo_veiculo,
        //     valor: valor_veiculo,
        //     tipo_veiculo: categoria,
        //   };

        //   this.vendas_perdidas.push(arr); // Adiciona o novo objeto ao array
        // }

        console.log(this.vendas_perdidas);
      } catch (error) {
        console.log(error);
        this.abrir_modal = true;
        this.msg = error;
        setTimeout(() => (this.abrir_modal = false), 4000);
      }
    },
    async relatorio_venda_modelo() {
      console.log("Chamar relatório de venda por modelo");
      console.log("chamar relatório de venda perdida");

      const params = this.getRequestParams(
        this.selectedEmpresas,
        this.page,
        this.pageSize,
        this.company_id,
        this.user_id,
        this.startDate,
        this.endDate,
        this.selectedTipoVeiculo,
        this.selectedTipoConversao,
        this.selectedFilter
      );
      await axios
        .get(`${process.env.VUE_APP_API_URL}relatorio_vendas_modelo`, {
          params
        })
        .then((response) => {
          this.vendas_modelo = response.data.result;
          this.total_vendas_modelo = response.data.total[0]["TotalVendas"];
          this.kpis = response.data.kpis || {};
          console.log(response);
        })
        .catch((error) => {
          if (error.response.status == 400) {
            this.abrir_modal = true;
            this.msg = error.response.data.message;
          }
        });
    },
    async relatorio_atendimentos() {
      console.log("chamar relatório de atendimentos");

      // Limpa o array antes de adicionar novos elementos
      this.vendas_perdidas.splice(0);

      const params = this.getRequestParams(
        this.selectedEmpresas,
        this.page,
        this.pageSize,
        this.company_id,
        this.user_id,
        this.startDate,
        this.endDate,
        this.selectedTipoVeiculo,
        this.selectedTipoConversao,
        this.selectedFilter
      );
      console.log("Parametros", params);
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API_URL}relatorio_atendimentos`,
          { params }
        );
        const qtd = response.data.count;
        const { rows } = response.data;
        let gerente2 = "";
        let gerente1 = "";
        this.atendimentos = []; // Inicialize o array para armazenar os resultados

        console.log("Relatorio de Atendimentos", rows);

        for (let i = 0; i < qtd; i++) {
          const row = rows[i];

          if (row.gerente_id !== undefined && row.gerente_id !== null) {
            // Verifique se gerente_alteracao está presente e não é undefined
            if (row.gerentes && row.gerentes.username) {
              gerente1 = row.gerentes.username;
            } else {
              gerente1 = ""; // Adiciona um valor padrão novamente para cada loop
            }
          } else {
            gerente1 = ""; // Adiciona um valor padrão novamente para cada loop
          }

          if (
            row.gerente_id_alteracao !== undefined &&
            row.gerente_id_alteracao !== null
          ) {
            console.log(
              `Gerente ID Alteracao está definido: ${row.gerente_id_alteracao}`
            );

            // Verifique se gerente_alteracao está presente e não é undefined
            if (row.gerente_alteracao && row.gerente_alteracao.username) {
              gerente2 = row.gerente_alteracao.username;
              console.log(`Gerente encontrado:`, gerente2);
            } else {
              gerente2 = ""; // Adiciona um valor padrão novamente para cada loop
              console.log(
                "Gerente Alteracao não encontrado ou informações incompletas."
              );
            }
          } else {
            gerente2 = ""; // Adiciona um valor padrão novamente para cada loop
            console.log("Gerente ID Alteracao não está definido.");
          }

          const arr = {
            loja: row.empresa_proposta.nome,
            atendimento: row.id,
            data: row.createdAt,
            atendente: row.usuarios.username,
            vendedor:
              row.proposta_vendedores && row.proposta_vendedores.username
                ? row.proposta_vendedores.username
                : "",
            cliente: row.clientes.nome,
            telefone: row.clientes.tel,
            telefone2: row.clientes.cel,
            email: row.clientes.email,
            midia: row.midias.descricao,
            retorno: row.retorno,
            tipo_fechamento: row.status_proposta,
            gerente: gerente1,
            gerente2: gerente2,
            menu: row.menus,
            tempo_de_atendimento: row.total_tempo_atendimento,
            observacao: row.obs
          };

          this.atendimentos.push(arr); // Adiciona o novo objeto ao array
        }

        console.log(this.atendimentos);
      } catch (error) {
        console.log(error);
        if (error.response && error.response.status == 400) {
          this.abrir_modal = true;
          this.msg = error.response.data.message;
        }
      }
    },
    async getEmpresas() {
      console.log("Buscando Empresas");
      const user_id = this.user_id;
      await axios
        .get(`${process.env.VUE_APP_API_URL}user_empresas`, {
          params: { id: user_id }
        })
        .then((response) => {
          this.lista_empresas = response.data;
          // Selecionar todas apenas na primeira vez
          if (this.selectedEmpresas.length === 0) {
            this.selectedEmpresas = this.lista_empresas.map((item) => item.id);
          }
        })
        .catch((error) => {
          if (error.response.status == 400) {
            this.abrir_modal = true;
            this.msg = error.response.data.message;
          }
        });
    },
    limpar_tabela() {
      console.log("Limpar Tabela");
      this.conversao_vendas = "";
      this.total_atendimentosNovos = "";
      this.total_vendasNovos = "";
      this.total_conversao_percNovos = "";
      this.total_atendimentosUsados = "";
      this.total_vendasUsados = "";
      this.total_conversao_percUsados = "";
      this.total_atendimentos = "";
      this.total_vendas = "";
      this.total_conversao_perc = "";
    },
    fmtBRL(n) {
      const value = Number(n || 0);
      const formatCompact = (val, suffix) => {
        const num = val.toFixed(2);
        // remove .00 quando não precisa
        const clean = num.endsWith(".00") ? num.slice(0, -3) : num;
        return `R$ ${clean}${suffix}`;
      };

      if (value >= 1000000000) return formatCompact(value / 1000000000, "B");
      if (value >= 1000000) return formatCompact(value / 1000000, "M");
      if (value >= 1000) return formatCompact(value / 1000, "K");

      return value.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },
    filtrarConversao() {
      if (this.selectedFilter === "Todas Lojas") {
        // console.log("Filtar propostas em atendimento! ------------------------------------------------------------------------------------------------------------------ 0005")
        this.status_proposta = this.selectedFilter;
        this.relatorio_conversao_vendas();
      } else if (this.selectedFilter === "Venda Finalizada") {
        // console.log("Filtar propostas em Finalizadas! ------------------------------------------------------------------------------------------------------------------ 0006")
        this.status_proposta = this.selectedFilter;
        this.retrievePropostas();
      } else if (this.selectedFilter === "Venda Perdida") {
        this.status_proposta = this.selectedFilter;
        this.retrievePropostas();
        // console.log("Filtar propostas em vendas perdiadas! ------------------------------------------------------------------------------------------------------------------ 0007")
      } else if (this.selectedFilter === "Todos") {
        this.status_proposta = this.selectedFilter;
        this.retrievePropostas();
        // console.log("Filtar propostas em vendas perdiadas! ------------------------------------------------------------------------------------------------------------------ 0007")
      } else if (this.selectedFilter === "Dia") {
        this.status_proposta = this.selectedFilter;
        this.retrievePropostas();
        // console.log("Filtar propostas em vendas
      }
    },

    currency(number) {
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2
      }).format(number);
    }
  }
};
</script>
<style scoped>
.bi-best-performance {
  padding: 0.5rem 0;
}

.performance-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1rem;
  padding: 0.5rem;
  background: #f8f9fa;
  border-radius: 8px;
}

.performance-item i {
  font-size: 1.5rem;
}

.performance-text {
  font-weight: 600;
  font-size: 1rem;
  color: #2c3e50;
  word-break: break-word;
}

.performance-metric {
  padding: 0.5rem;
}

.performance-metric > div {
  margin-bottom: 0.5rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.performance-metric i {
  width: 20px;
  color: #6c757d;
}

.text-warning {
  color: #ffc107 !important;
}

.bg-success {
  background-color: #28a745 !important;
}
/* Ranking Medals */
.ranking-medal {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  margin: 0 auto;
}

.ranking-medal.gold {
  background: linear-gradient(135deg, #ffd700, #ffb347);
  color: white;
  box-shadow: 0 2px 8px rgba(255, 215, 0, 0.3);
}

.ranking-medal.silver {
  background: linear-gradient(135deg, #c0c0c0, #a0a0a0);
  color: white;
  box-shadow: 0 2px 8px rgba(192, 192, 192, 0.3);
}

.ranking-medal.bronze {
  background: linear-gradient(135deg, #cd7f32, #b87333);
  color: white;
  box-shadow: 0 2px 8px rgba(205, 127, 50, 0.3);
}

.ranking-number {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #f8f9fa;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  color: #6c757d;
  margin: 0 auto;
}

/* Avatar Circle */
.avatar-circle {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  color: white;
  font-size: 18px;
}

.avatar-circle-lg {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 32px;
}

.bg-gradient-primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.text-white-50 {
  color: rgba(255, 255, 255, 0.7);
}

.border-white-50 {
  border-color: rgba(255, 255, 255, 0.2) !important;
}
/* Estilo dos cards de KPI */
.card {
  border-radius: 12px;
  transition: transform 0.2s, box-shadow 0.2s;
}

.card:hover {
  transform: translateY(-2px);
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}

.bg-primary.bg-opacity-10 {
  background-color: rgba(13, 110, 253, 0.1);
}

.bg-success.bg-opacity-10 {
  background-color: rgba(25, 135, 84, 0.1);
}

.bg-warning.bg-opacity-10 {
  background-color: rgba(255, 193, 7, 0.1);
}

.bg-info.bg-opacity-10 {
  background-color: rgba(13, 202, 240, 0.1);
}

.progress {
  background-color: #e9ecef;
  border-radius: 2px;
}

.progress-bar {
  border-radius: 2px;
}
/* Power BI Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
  backdrop-filter: blur(4px);
  animation: fadeIn 0.2s ease;
}

.powerbi-modal {
  background: #ffffff;
  border-radius: 12px;
  max-width: 1100px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  animation: slideUp 0.3s ease;
}

/* Header Power BI */
.powerbi-modal-header {
  background: linear-gradient(135deg, #1e2a3a 0%, #0f172a 100%);
  color: white;
  padding: 24px 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.powerbi-icon-wrapper {
  width: 48px;
  height: 48px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
}

.powerbi-modal-title {
  font-size: 20px;
  font-weight: 600;
  margin: 0;
  letter-spacing: -0.3px;
}

.powerbi-modal-subtitle {
  font-size: 13px;
  opacity: 0.7;
  margin: 4px 0 0 0;
}

.powerbi-close-btn {
  background: rgba(255, 255, 255, 0.1);
  border: none;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  color: white;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.powerbi-close-btn:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: scale(1.05);
}

/* Body */
.powerbi-modal-body {
  padding: 32px;
  background: #f8f9fc;
}

/* KPI Cards Grid */
.powerbi-kpi-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-bottom: 32px;
}

.powerbi-kpi-card {
  background: white;
  border-radius: 12px;
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  border: 1px solid #e9ecef;
  transition: all 0.3s;
}

.powerbi-kpi-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
}

.kpi-icon {
  width: 52px;
  height: 52px;
  background: linear-gradient(135deg, #922020 0%, #6e1818 100%);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: white;
}

.kpi-content {
  flex: 1;
}

.kpi-label {
  font-size: 12px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #6c757d;
  margin-bottom: 8px;
}

.kpi-value {
  font-size: 20px;
  font-weight: 700;
  color: #1e2a3a;
}

/* Sections */
.powerbi-section {
  background: white;
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  border: 1px solid #e9ecef;
}

.powerbi-section-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 24px;
  position: relative;
}

.powerbi-section-header i {
  font-size: 20px;
  color: #922020;
}

.powerbi-section-header h6 {
  font-size: 16px;
  font-weight: 600;
  color: #1e2a3a;
  margin: 0;
}

.section-line {
  flex: 1;
  height: 2px;
  background: linear-gradient(90deg, #922020 0%, transparent 100%);
}

/* Info Grid */
.powerbi-info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 20px;
}

.powerbi-info-item {
  padding: 12px;
  background: #f8f9fc;
  border-radius: 8px;
  transition: all 0.2s;
}

.powerbi-info-item:hover {
  background: #f1f3f5;
  transform: translateX(4px);
}

.info-label {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #6c757d;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.info-label i {
  font-size: 12px;
}

.info-value {
  font-size: 15px;
  font-weight: 500;
  color: #1e2a3a;
  word-break: break-word;
}

.info-placa {
  font-family: monospace;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 1px;
}

/* Vehicle Highlight */
.powerbi-vehicle-highlight {
  background: linear-gradient(135deg, #f8f9fc 0%, #ffffff 100%);
  border-left: 4px solid #922020;
  padding: 20px;
  margin-bottom: 24px;
  border-radius: 8px;
}

.vehicle-main-info {
  display: flex;
  align-items: center;
  gap: 20px;
}

.vehicle-icon {
  width: 60px;
  height: 60px;
  background: #92202010;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  color: #922020;
}

.vehicle-title {
  font-size: 18px;
  font-weight: 700;
  color: #1e2a3a;
  margin-bottom: 4px;
}

.vehicle-subtitle {
  font-size: 13px;
  color: #6c757d;
}

/* Observations */
.powerbi-observations {
  background: #f8f9fc;
  padding: 20px;
  border-radius: 8px;
  display: flex;
  gap: 12px;
  align-items: flex-start;
}

.powerbi-observations i {
  font-size: 24px;
  color: #922020;
  opacity: 0.5;
}

.powerbi-observations p {
  margin: 0;
  font-size: 14px;
  line-height: 1.6;
  color: #495057;
}

/* Footer */
.powerbi-modal-footer {
  padding: 20px 32px;
  border-top: 1px solid #e9ecef;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  background: white;
}

.powerbi-btn-primary,
.powerbi-btn-secondary {
  padding: 10px 20px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  transition: all 0.2s;
  cursor: pointer;
  border: none;
}

.powerbi-btn-primary {
  background: linear-gradient(135deg, #922020 0%, #6e1818 100%);
  color: white;
}

.powerbi-btn-primary:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(146, 32, 32, 0.3);
}

.powerbi-btn-secondary {
  background: #f8f9fc;
  color: #6c757d;
  border: 1px solid #dee2e6;
}

.powerbi-btn-secondary:hover {
  background: #e9ecef;
  transform: translateY(-1px);
}

/* Animations */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideUp {
  from {
    transform: translateY(30px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

/* Scrollbar personalizada */
.powerbi-modal::-webkit-scrollbar {
  width: 8px;
}

.powerbi-modal::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.powerbi-modal::-webkit-scrollbar-thumb {
  background: #922020;
  border-radius: 4px;
}

.powerbi-modal::-webkit-scrollbar-thumb:hover {
  background: #6e1818;
}

/* Responsive */
@media (max-width: 768px) {
  .powerbi-modal {
    width: 95%;
    max-height: 95vh;
  }

  .powerbi-modal-body {
    padding: 20px;
  }

  .powerbi-kpi-grid {
    grid-template-columns: 1fr;
  }

  .powerbi-info-grid {
    grid-template-columns: 1fr;
  }

  .vehicle-main-info {
    flex-direction: column;
    text-align: center;
  }
}
.status-approved {
  color: #28a745 !important;
}

.status-pending {
  color: #ffc107 !important;
}

.status-rejected {
  color: #dc3545 !important;
}
.btn-avaliacao {
  --bs-btn-color: #fff;
  --bs-btn-bg: #922020;
  --bs-btn-border-color: #6e1818;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #6e1818;
  --bs-btn-hover-border-color: #4a1010;
  --bs-btn-focus-shadow-rgb: 146, 32, 32;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #4a1010;
  --bs-btn-active-border-color: #3a0c0c;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #6e1818;
  --bs-btn-disabled-border-color: #4a1010;
}

.btn-check:checked + .btn,
.btn.active,
.btn.show,
.btn:first-child:active,
:not(.btn-check) + .btn:active {
  color: var(--bs-btn-active-color);
  background-color: #4a1010;
  border-color: #3a0c0c;
}

/* Cards de BI */
.bi-card {
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border-radius: 16px;
  padding: 1.25rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  transition: transform 0.2s, box-shadow 0.2s;
  height: 100%;
}

.bi-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
}

.bi-card-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1rem;
}

.bi-card-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  color: white;
}

.bg-primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.bg-success {
  background: linear-gradient(135deg, #84fab0 0%, #8fd3f4 100%);
}

.bg-warning {
  background: linear-gradient(135deg, #fad0c4 0%, #ffd1ff 100%);
}

.bg-info {
  background: linear-gradient(135deg, #a1c4fd 0%, #c2e9fb 100%);
}

.bg-danger {
  background: linear-gradient(135deg, #ff9a9e 0%, #fecfef 100%);
}

.bi-card-title {
  font-size: 1rem;
  font-weight: 600;
  color: #2c3e50;
  letter-spacing: 0.5px;
}

.bi-card-body {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.bi-metric {
  text-align: center;
  padding: 0.5rem;
}

.metric-value {
  font-size: 2rem;
  font-weight: 700;
  color: #2c3e50;
  line-height: 1.2;
}

.metric-label {
  font-size: 0.75rem;
  color: #7f8c8d;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-top: 0.25rem;
}

/* Comparativo Novos vs Usados */
.bi-comparison {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.comparison-item {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  padding: 0.5rem;
  background: #f8f9fa;
  border-radius: 8px;
}

.comparison-label {
  font-size: 0.85rem;
  font-weight: 500;
  color: #2c3e50;
}

.comparison-value {
  font-size: 1.25rem;
  font-weight: 700;
  color: #3498db;
}

.comparison-percent {
  font-size: 0.85rem;
  color: #27ae60;
  font-weight: 600;
}

.comparison-divider {
  height: 1px;
  background: linear-gradient(90deg, transparent, #e0e0e0, transparent);
}

/* Ranking */
.bi-ranking {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.ranking-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.5rem;
  background: #f8f9fa;
  border-radius: 8px;
  transition: background 0.2s;
}

.ranking-item:hover {
  background: #e9ecef;
}

.ranking-position {
  width: 32px;
  height: 32px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 0.85rem;
}

.ranking-name {
  flex: 1;
  font-size: 0.9rem;
  font-weight: 500;
  color: #2c3e50;
}

.ranking-value {
  font-size: 0.85rem;
  font-weight: 600;
  color: #27ae60;
}

/* Melhor Performance */
.bi-best-performance {
  text-align: center;
}

.performance-item {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
  font-size: 1rem;
  font-weight: 600;
  color: #2c3e50;
}

.performance-metric {
  display: flex;
  justify-content: space-around;
  gap: 1rem;
  font-size: 0.85rem;
  color: #7f8c8d;
  background: #f8f9fa;
  padding: 0.5rem;
  border-radius: 8px;
}

/* Responsividade */
@media (max-width: 768px) {
  .bi-card {
    margin-bottom: 1rem;
  }

  .metric-value {
    font-size: 1.5rem;
  }

  .ranking-position {
    width: 28px;
    height: 28px;
    font-size: 0.75rem;
  }
}
.table-bi thead {
  background: #f9fafb;
  border-bottom: 1px solid #e5e7eb;
}
.table-bi th {
  font-size: 10px;
  font-weight: 700;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  padding: 14px 16px;
  white-space: nowrap;
}
.table-bi tbody tr {
  border-bottom: 1px solid #f1f5f9;
}
.table-bi tbody tr:nth-child(even) {
  background: #fcfcfd;
}
.table-bi tbody tr:hover {
  background: #f1f5f9;
  transition: 0.2s;
}
.table-bi thead {
  position: sticky;
  top: 0;
  z-index: 5;
}
.th-sub {
  font-size: 9px;
  color: #9ca3af;
  font-weight: 600;
}

/* LARGURAS OTIMIZADAS */
.col-small {
  width: 90px;
  text-align: center;
}
.col-medium {
  width: 140px;
}
.col-large {
  width: 260px;
}
.col-phone {
  width: 140px;
}
.col-date {
  width: 110px;
  text-align: center;
}
.col-time {
  width: 110px;
  text-align: center;
}
.col-actions {
  width: 90px;
}

/* CELULAS */
.table-bi td {
  padding: 16px;
  vertical-align: middle;
}

/* TEXTO */
.cell-main {
  font-size: 14px;
  font-weight: 600;
  color: #111827;
}

.cell-sub {
  font-size: 11px;
  color: #9ca3af;
  margin-top: 2px;
}

/* CONTROLE DE TEXTO GRANDE */
.truncate {
  max-width: 180px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* HOVER */
.table-bi-row:hover {
  background: #f8fafc;
  transition: 0.2s;
}

/* ALINHAMENTO */
.text-end {
  text-align: right;
}
/* base */
.cell-main {
  font-size: 14px;
  font-weight: 700;
}

/* rápido */
.tempo-rapido .cell-main {
  color: #16a34a;
}

/* médio */
.tempo-medio .cell-main {
  color: #f59e0b;
}

/* lento */
.tempo-lento .cell-main {
  color: #ef4444;
}

/* crítico (tem dias) */
.tempo-critico .cell-main {
  color: #b91c1c;
}
.tempo-rapido {
  background: #ecfdf5;
}

.tempo-medio {
  background: #fffbeb;
}

.tempo-lento {
  background: #fef2f2;
}

.tempo-critico {
  background: #fee2e2;
}

/* secundário */
.cell-sub {
  font-size: 11px;
  color: #9ca3af;
}

.tooltip-wrapper {
  position: relative;
  display: inline-block;
}

/* tooltip */
.tooltip-box {
  position: absolute;
  top: -8px;
  left: 0;
  transform: translateY(-100%);

  background: #818ca3;
  color: #fff;

  padding: 10px 10px;
  border-radius: 200px;

  font-size: 11px;
  white-space: nowrap;

  opacity: 0;
  pointer-events: none;

  transition: 0.2s ease;
  z-index: 9999;
}

/* seta */
.tooltip-box::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 200px;

  border-width: 5px;
  border-style: solid;
  border-color: #111827 transparent transparent transparent;
}

/* hover */
.tooltip-wrapper:hover .tooltip-box {
  opacity: 1;
  transform: translateY(0);
}

.grid-kpi-header {
  grid-template-columns: 2fr 1fr 1fr 1fr;
}

.grid-kpi-row {
  grid-template-columns: 2fr 1fr 1fr 1fr;
}
</style>
